import baseRequest, { setToken } from "./baseRequest";
//comment
export const userServices = {
    changePassword: async (data) => baseRequest(data, "/user/ChangePassword", "post",true),
    updateProfileUser: async (data) => baseRequest(data, "/user/updateProfileUser", "put",true),
    getUserForProfile: async data => baseRequest(null, "/user/GetUserForProfile", "get",true),


    getUserForProfileForLocalStorage: async () => {
        const res = await baseRequest(null, "/user/GetUserForProfile", "get",true);
        if (res.isSuccess) {
          localStorage.setItem("user-profile", JSON.stringify(res.data));
          return res;
        }
      },
}